import { gql, TypedDocumentNode } from '@common/hooks';
import {
  ServiceLineTeamFiltersQueryCgResponse,
  ServiceLineTeamFiltersQueryVariables,
} from '@common/graphql';

// Filter vocabulary for the Service Line Team Review page: the service line's
// organization units (Unit column filter) and configured clinical role abbreviations
// (Role column filter). Both include entries with no current workers, so the filters
// offer the service line's full configured set. Replaces the global `roles` query.
export const SERVICE_LINE_TEAM_FILTERS_QUERY: TypedDocumentNode<
  ServiceLineTeamFiltersQueryCgResponse,
  ServiceLineTeamFiltersQueryVariables
> = gql`
  query ServiceLineTeamFilters($serviceLineId: ID!) {
    serviceLineTeamFilters(serviceLineId: $serviceLineId) {
      chargeRole
      roles
      units {
        id
        name
      }
    }
  }
`;
